function WarehouseForm() {
  return <div><h2>Add/Edit Warehouse</h2><p>Warehouse form will go here.</p></div>;
}
export default WarehouseForm; 